import React from 'react';
import {Email_check} from "../../assets/images/images"

const SuccessScreen = ({ onRaiseNewTicket }) => {
  return (
    <div className="success-screen-wrapper">
      <div className="success-screen-content">
        <img src={Email_check} alt='Email-check' className="success-icon"/>
       
        {/* Success Message */}
        <h2 className="success-title">
          Your ticket has been raised
        </h2>
        
        <p className="success-description">
          Our team will get back to you shortly
        </p>

        {/* Raise New Ticket Button */}
        <button
          onClick={onRaiseNewTicket}
          className="raise-ticket-button"
        >
          Raise a new ticket
        </button>
      </div>
    </div>
  );
};

export default SuccessScreen;